const KEY_VALUES = {
  AUTH_LOCAL_STORAGE_KEY_FORGOT: "@merchant/forgot_data",
  AUTH_LOCAL_STORAGE_KEY: "@merchant/auth_data",
  AUTH_LOCAL_STORAGE_KEY_WHITELABEL_UUID:
    "@merchant/whitelabel_uuid",
  AUTH_SEARCH_PARAMS_KEY: "authentication",
  ACCEPT_KEY: "accept",
  ACCEPT_VALUE: "application/json, text/plain, */*",
  CONTENT_TYPE_KEY: "Content-Type",
  CONTENT_TYPE_VALUE: "application/json",
  X_ACCESS_TOKEN_KEY: "X-Access-Token",
  INVALID_ACCESS_TOKEN_KEY: "INVALID_ACCESS_TOKEN",
  WHITELABEL_NO_CUSTOM_DOMAINS_KEY:
    "@merchant/no_whitelabel_domains",
} as const
export default KEY_VALUES
